import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import { TextStyle } from '@ticketmaster/global-design-system';

import { T } from '@/v2/helpers/i18n';

import styles from './section.module.scss';

type Props = {
  sectionName: string;
} & T;

const InfoSection = ({ t, sectionName = '' }: Props) => {
  return (
    <div className={styles.infoSection}>
      <TextStyle.Snowdon>{t(sectionName).toUpperCase()}</TextStyle.Snowdon>
    </div>
  );
};

export default withTranslation('translation')(memo(InfoSection));
